import Vue from 'vue'

export default Vue.extend({
  name: 'Confirm',

  props: {
    title: {
      type: String as Prop<string>
    },
    to: {
      type: String as Prop<string>
    },
    description: {
      type: String as Prop<string>
    },
    buttonText: {
      type: String as Prop<string>,
      default: 'ログインページに戻る'
    }
  },
  methods: {
    redirectLink () {
      this.$router.push({ path: `/${this.to}` })
    }
  }
})
